import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import TextHeadingOne from '../atoms/TextHeadingOne';
import TextParagraph from '../atoms/TextParagraph';
import FormButton from '../atoms/FormButton';
import Modal from './Modal';
import LabeledTextfield from '../molecules/LabeledTextfield';

//Returning the component
class FormChangePassword extends Component {
	render() {
		return (
			<Modal modalClass={this.props.modalClass}>
				<form className={`form formDeleteBot ${this.props.formWrapperClassType}`}>
					<TextHeadingOne text="Change password" />
					<TextParagraph text="Enter the details below" />
					{/* Current password */}
					<LabeledTextfield
						formGroupClassType={this.props.formGroupClassType}
						labelFor="currentPassword"
						labelText="Current password"
						labelId="currentPassword"
						textfieldClassType={this.props.textfieldClassType}
						textfieldId="currentPassword"
						textfieldPlaceholder={this.props.currentPassword}
						textfieldName='currentPasswordInput'
						textfieldOnChange={this.props.currentPasswordOnChange}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={this.props.errorMessageCurrentPassword}
						required={true}
						inputType="password"
					/>
					{/* new password */}
					<LabeledTextfield
						formGroupClassType={this.props.formGroupClassType}
						labelFor="newPassword"
						labelText="New password"
						labelId="newPassword"
						textfieldClassType={this.props.textfieldClassType}
						textfieldId="newPassword"
						textfieldPlaceholder={this.props.newPassword}
						textfieldName='newPasswordInput'
						textfieldOnChange={this.props.newPasswordOnChange}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={this.props.errorMessageNewPassword}
						required={true}
						inputType="password"
					/>
					{/* Confirm new password*/}
					<LabeledTextfield
						formGroupClassType={this.props.formGroupClassType}
						labelFor="confirmNewPassword"
						labelText="Confirm new password"
						labelId="confirmNewPassword"
						textfieldClassType={this.props.textfieldClassType}
						textfieldId="confirmNewPassword"
						textfieldPlaceholder={this.props.confirmNewPassword}
						textfieldName='confirmNewPasswordInput'
						textfieldOnChange={this.props.confirmNewPasswordOnChange}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={this.props.errorMessageConfirmNewPassword}
						required={true}
						inputType="password"
					/>
					<FormButton text="Change password" classType="btn--fullWidth" onClick={this.props.onClick} />
				</form>
			</Modal>
		)
	}
}

//Making sure that it has a text property when it's declared
FormChangePassword.propTypes = {
	test: PropTypes.string, //Write some props here if needed, just using this to not have errors
}

export default FormChangePassword;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormChangePassword.jsx